import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {
    createCategory,
    deleteCategory,
    getCategories,
    getCategoryByCategory,
    updateCategory
} from "../api/categoryApi";
import {useNavigate} from "react-router";
import {Category} from "../types";

export const useCategories = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();


    const {data: categories, isLoading} = useQuery<Category[]>({
        queryKey: ['categories'],
        queryFn: getCategories,
    });

    const mutationCreate = useMutation({
        mutationFn: createCategory,
        onSuccess: (data) => {
            queryClient.invalidateQueries({queryKey: ['categories']});
            navigate(`/category/${data.category}`);
        },
    });

    const mutationUpdate = useMutation({
        mutationFn: ({id, category}: { id: string; category: any }) => updateCategory(id, category),
        onSuccess: () => queryClient.invalidateQueries({queryKey: ['categories']}),
    });

    const mutationDelete = useMutation({
        mutationFn: ({id}: { id: string }) => deleteCategory(id),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['categories']})
            navigate('/')
        },
    });

    return {categories, isLoading, mutationCreate, mutationUpdate, mutationDelete};
};

export const useCategory = (categoryName: string) => {

    const {data: category, isLoading} = useQuery({
        queryKey: ['category', categoryName],
        queryFn: () => getCategoryByCategory(categoryName),
        enabled: !!categoryName,
    });

    return {category, isLoading};
};